export default Object.freeze({
    CLOSE_APP: 'CLOSE_APP',
    OPEN_APP: 'OPEN_APP',
    OPEN_WINDOW: 'OPEN_WINDOW',
    CLOSE_WINDOW: 'CLOSE_WINDOW',
    PREPEND_WINDOW: 'PREPEND_WINDOW',
    REPLACE_ID: 'REPLACE_ID'
});
